import { render, staticRenderFns } from "./project-add-rate-fixed.vue?vue&type=template&id=499809c4&"
import script from "./project-add-rate-fixed.vue?vue&type=script&lang=js&"
export * from "./project-add-rate-fixed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports